export type MutationLoadingLike = {
  isPending?: boolean;
  isLoading?: boolean;
};

export const getMutationPendingState = (mutation: MutationLoadingLike): boolean =>
  mutation.isPending ?? mutation.isLoading ?? false;
